// Loads the Square Web Payments SDK once per page. Subsequent calls reuse
// the existing <script> and invoke the callback once it has settled so any
// per-input initialization can run.
//
// The callback also runs when the script fails to load (blocked by a content
// blocker, network error): the caller checks `window.Square` and shows its
// load error instead of an endless spinner.

const SETTLED_ATTR = 'data-settled';

export const loadSquareCardPayments = (loadFunction?: () => void): void => {

	const id = 'square-web-payments';
	const src = process.env.NEXT_PUBLIC_BUILD_SQUARE_CARD_PAYMENT_SDK || '';

	// Prevent script from loading twice; still execute loadFunction so the
	// caller's input can attach to the already-loaded SDK. If the script is
	// still in flight (e.g. the customer switched payment methods quickly),
	// wait for it rather than initializing against a missing SDK.
	const existing = document.getElementById(id);
	if(existing) {
		if(!loadFunction) { return; }
		if(existing.hasAttribute(SETTLED_ATTR)) {
			loadFunction();
		} else {
			existing.addEventListener('load', loadFunction, { once: true });
			existing.addEventListener('error', loadFunction, { once: true });
		}
		return;
	}

	const js = document.createElement('script');
	js.id = id;
	js.src = src;
	js.onload = () => {
		js.setAttribute(SETTLED_ATTR, 'load');
		loadFunction?.();
	};
	js.onerror = () => {
		js.setAttribute(SETTLED_ATTR, 'error');
		loadFunction?.();
	};

	const firstJs = document.getElementsByTagName('script')[0];
	if(firstJs?.parentNode) {
		firstJs.parentNode.insertBefore(js, firstJs);
	} else {
		document.head.appendChild(js);
	}
};
